import { useEffect, useState } from "react";
import Topbar from "../layouts/Topbar";
import { Avatar, Card, CardContent, Typography } from "@mui/material";
import user from "../../Admin/assets/icons/dash_users.svg";
import consultations from "../../Admin/assets/icons/dash_consultations.svg";
import orders from "../../Admin/assets/icons/dash_orders.svg";
import uploads from "../../Admin/assets/icons/dash_uploads.svg";
import delivers from "../../Admin/assets/icons/dash_delivers.svg";
import ReactApexChart from "react-apexcharts";
import { LineChart } from "@mui/x-charts/LineChart";
import instance from "../../Utils/api";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";


const AdminDashboard = () => {
  const navigate = useNavigate();
  const role = localStorage.getItem('role');
  const [dashboardTilesData, setDashboardTilesData] = useState([]);
  const [year, setYear] = useState(new Date().getFullYear());
  const [revenueData, setRevenueData] = useState([]);
  const [type, setType] = useState("Category");
  const [ordertype, setOrderType] = useState("SubOrder");
  const [statusType, setStatusType] = useState(role === 'JuniorDesigner' ? "SubOrder" : "Order");
  const [statusData, setStatusData] = useState([]);
  const [pieData, setPieData] = useState([]);
  const [name, setName] = useState([]);
  const [chartData, setChartData] = useState([]);


  const getAdmin = async () => {
    try {
      const response = await instance.get("/Admin/getAdminById");
      setName(response?.data?.data?.name);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchDashboardTilesData = async () => {
    try {
      const response = await instance.get("/Common/dashboardBanner");
      setDashboardTilesData(response?.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchStatusData = async () => {
    try {
      const response = await instance.get(`/Common/orderStatusCounts?type=${role === 'JuniorDesigner' ? "SubOrder" : "Order"}`);
      setStatusData(response?.data?.data)
    } catch (err) {
      console.log(err);
    }
  }

  const [dataSet, setDataSet] = useState([
    { x: 1, y: 0 }, // Jan
    { x: 2, y: 0 }, // Feb
    { x: 3, y: 0 }, // Mar
    { x: 4, y: 0 }, // Apr
    { x: 5, y: 0 }, // May
    { x: 6, y: 0 }, // Jun
    { x: 7, y: 0 }, // Jul
    { x: 8, y: 0 }, // Aug
    { x: 9, y: 0 }, // Sep
    { x: 10, y: 0 }, // Oct
    { x: 11, y: 0 }, // Nov
    { x: 12, y: 0 }, // Dec
  ]);

  const fetchRevenueData = async () => {
    try {
      const response = await instance.get(`/Common/revenue?year=${year}`);

      // ensure response months are numbers
      const apiData = response?.data?.data || [];

      const updatedDataSet = dataSet.map((entry) => {
        const monthData = apiData.find((data) => Number(data.month) === entry.x);

        return {
          ...entry,
          y: monthData ? Number(monthData.donePayments) : 0,
        };
      });

      setRevenueData(apiData);
      setDataSet(updatedDataSet);

    } catch (err) {
      console.log(err);
    }
  };

  const monthLabels = [
    "", // Empty placeholder for 0
    "Jan", // 1
    "Feb", // 2
    "Mar", // 3
    "Apr", // 4
    "May", // 5
    "Jun", // 6
    "Jul", // 7
    "Aug", // 8
    "Sep", // 9
    "Oct", // 10
    "Nov", // 11
    "Dec", // 12
  ];

  useEffect(() => {
    fetchRevenueData();
  }, [year]);

  const totalRevenue = revenueData.reduce((acc, revenue) => acc + (revenue?.totalAmount || 0), 0);

  const fetchPieChartData = async () => {
    try {
      const response = await instance.get(
        `/Common/mostOrdered?limit=${5}`
      );
      setPieData(response?.data?.data);
    } catch (err) {
      console.log(err);
    }
  };

  const pieOptions = {
    labels: pieData?.map((item) => item?.name ?? "Unknown") || [],
    legend: {
      position: "bottom",
    },
  };

  const pieSeries = pieData?.map((item) => Number(item?.count ?? 0)) || [];

  const fetchpriorityorders = async () => {
    try {
      const response = await instance.get(
        `/Common/priorityOrders?type=${ordertype}`
      );
      setChartData(response?.data?.data);
    } catch (err) {
      console.log(err);
    }
  };

  const navigateToPagecount = (categoryId, ordertype) => {
    const filterMapping = {
      Delay: "delay",
      Today: 0,
      Tomorrow: 1,
      "Day After Tomorrow": 2,
      "Comming 7 Days": "next7days",
    };

    const calculateDateRange = (offset) => {
      const today = new Date();

      if (offset === "delay") {
        // For Delay: all dates before today (overdue orders)
        const end = new Date(today);
        end.setHours(23, 59, 59, 999);

        return {
          start: null, // No start date - everything before endDate
          end: end
        };
      } else if (offset === "next7days") {
        // For Comming 7 Days: today + next 6 days (7 days total)
        const start = new Date(today);
        start.setHours(0, 0, 0, 0);

        const end = new Date(today);
        end.setDate(end.getDate() + 6); // Today + 6 days = 7 days total
        end.setHours(23, 59, 59, 999);

        return { start, end };
      } else {
        // For Today, Tomorrow, Day After Tomorrow
        const targetDate = new Date(today);
        targetDate.setDate(targetDate.getDate() + offset);

        const start = new Date(targetDate);
        start.setHours(0, 0, 0, 0);

        const end = new Date(targetDate);
        end.setHours(23, 59, 59, 999);

        return { start, end };
      }
    };

    let decodedCategoryId = "";
    try {
      decodedCategoryId = decodeURIComponent(categoryId);
    } catch (error) {
      console.error("Error decoding categoryId:", error);
      decodedCategoryId = categoryId;
    }

    const offset = filterMapping[decodedCategoryId] ?? 0;
    const dateRange = calculateDateRange(offset);

    const formatDate = (date) => {
      return date ? date.toISOString() : "";
    };

    const baseRoutes = {
      Order: '/admin/orders',
      SubOrder: role === 'JuniorDesigner' ? '/admin/suborders' : '/admin/orders',
      Consultation: '/admin/consultation',
    };

    const basePath = baseRoutes[ordertype];
    if (basePath) {
      const params = new URLSearchParams({
        filtertype: 'deadline'
      });

      if (dateRange.start) {
        params.append('startDate', formatDate(dateRange.start));
      }

      if (dateRange.end) {
        params.append('endDate', formatDate(dateRange.end));
      }

      navigate(`${basePath}?${params.toString()}`);
    } else {
      console.error("Invalid ordertype:", ordertype);
    }
  };

  const barChartOptionscount = {
    chart: {
      type: "bar",
      height: 350,
      toolbar: {
        show: false,
      },
      events: {
        dataPointSelection: (event, chartContext, config) => {
          const clickedCategory = config.w.config.xaxis.categories[config.dataPointIndex];
          navigateToPagecount(clickedCategory, ordertype);
        },
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 10,
        horizontal: true,
        barHeight: "70%",
        distributed: true,
      },
    },
    colors: ["#ff0000ff", "#ff4d4d", "#ffcc66", "#66cc66", "#00ff00ff"],
    dataLabels: {
      enabled: true,
      style: {
        colors: ["#fff"],
      },
    },
    xaxis: {
      categories: ["Delay", "Today", "Tomorrow", "Day After Tomorrow", "Comming 7 Days"],
    },
    legend: {
      position: "bottom",
    },
  };

  const barChartSeriescount = [
    {
      name: "Orders",
      data: Object.values(chartData),
    },
  ];

  const handleTileClick = (statusData) => {
    navigate(`/admin/orders/${statusData._id}`)
  }

  useEffect(() => {
    getAdmin();
    fetchDashboardTilesData();
  }, []);

  useEffect(() => {
    fetchpriorityorders();
  }, [ordertype]);

  useEffect(() => {
    fetchPieChartData();
  }, [type]);

  useEffect(() => {
    fetchStatusData();
  }, [statusType])


  return (
    <div>
      <Topbar />
      <div className="admin-dashboard-container">
        <Typography variant="h2">
          Hello <span className="wave">&#128075;</span> {name}, Have a great day
        </Typography>

        <div className="admin-dashboard-card-container">
          <Card onClick={() => navigate('/admin/users')}>
            <CardContent className="dashboard-card-content">
              <Avatar className="dashboard-tile-img" src={user} />
              <Typography className="dashboard-tile-count">
                {dashboardTilesData?.totaCustomers}
              </Typography>
              <Typography className="dashboard-tile-title">
                Total Users
              </Typography>
            </CardContent>
          </Card>
          <Card onClick={() => navigate('/admin/consultation')}>
            <CardContent className="dashboard-card-content">
              <Avatar className="dashboard-tile-img" src={consultations} />
              <Typography className="dashboard-tile-count">
                {dashboardTilesData?.totalConsultations}
              </Typography>
              <Typography className="dashboard-tile-title">
                Total Consultations
              </Typography>
            </CardContent>
          </Card>
          <Card onClick={() => role === 'JuniorDesigner' ? navigate('/admin/suborders') : navigate('/admin/orders')}>
            <CardContent className="dashboard-card-content">
              <Avatar className="dashboard-tile-img" src={orders} />
              <Typography className="dashboard-tile-count">
                {dashboardTilesData?.totalCatOrders}
              </Typography>
              <Typography className="dashboard-tile-title">
                Catalogue Orders
              </Typography>
            </CardContent>
          </Card>
          <Card onClick={() => role === 'JuniorDesigner' ? navigate('/admin/suborders') : navigate('/admin/orders')}>
            <CardContent className="dashboard-card-content">
              <Avatar className="dashboard-tile-img" src={uploads} />
              <Typography className="dashboard-tile-count">
                {dashboardTilesData?.totalCusOrders}
              </Typography>
              <Typography className="dashboard-tile-title">
                Custom Design Orders
              </Typography>
            </CardContent>
          </Card>
          <Card onClick={() => role === 'JuniorDesigner' ? navigate('/admin/suborders') : navigate('/admin/orders')}>
            <CardContent className="dashboard-card-content">
              <Avatar className="dashboard-tile-img" src={delivers} />
              <Typography className="dashboard-tile-count">
                {dashboardTilesData?.totalDeliverd}
              </Typography>
              <Typography className="dashboard-tile-title">
                Total Delivered
              </Typography>
            </CardContent>
          </Card>
        </div>

        <div className="dashboard-graphs">
          <Grid container spacing={3}>
            {pieData?.length > 0 && (
              <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 7 }}>
                <Card>
                  <CardContent>
                    <div className="chart-container">
                      <div className="bar-header">
                        <div>
                          <Typography variant="h2">Orders Deadline</Typography>
                          <Typography variant="h3">This week Deadline orders</Typography>
                        </div>

                      </div>
                      <ReactApexChart
                        options={barChartOptionscount}
                        series={barChartSeriescount}
                        type="bar"
                        height={200}
                      />
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            )}

            {pieData?.length > 0 && (
              <Grid item size={{ xs: 12, sm: 12, md: 6, lg: 5 }}>
                <div className="piechart">
                  <Card>
                    <CardContent>
                      <div className="chart-container">
                        <div className="pie-header">
                          <h3>Most ordered catalogues</h3>
                        </div>
                        <ReactApexChart
                          options={pieOptions}
                          series={pieSeries}
                          type="pie"
                          height={280}
                        />
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </Grid>
            )}
          </Grid>
        </div>

        {(role === "Admin" || role === "SeniorDesigner") && (
          <>
            <div>
              <Typography variant="h2">Orders Status</Typography>
              <Typography variant="h3">Here you can check the status of all the orders</Typography>
            </div>

            <div className="admin-dashboard-card-container">
              {statusData && statusData.map((statusTile) => {
                return (
                  <Card sx={{ cursor: 'pointer' }} onClick={() => handleTileClick(statusTile)}>
                    <CardContent className="dashboard-card-content">
                      <Typography className="dashboard-tile-count">
                        {statusTile?.count}
                      </Typography>
                      <Typography className="dashboard-tile-title">
                        <div>{statusTile?._id}</div>
                      </Typography>
                    </CardContent>
                  </Card>
                )
              })
              }
            </div>
          </>
        )
        }


        {role === 'Admin' ?
          <div className="dashboard-graphs">
            <div className="linechart">
              <Card>
                <CardContent>
                  <div className="chart-container" style={{ height: '400px' }}>
                    <div className="bar-header">
                      <h2>Grand Total Amount: ₹ {totalRevenue}</h2>
                      {/* <FormControl
                        className="year-select"
                        variant="outlined"
                        sx={{ width: "150px", marginBottom: "2px" }}
                      >
                        <InputLabel id="year-select-label">Year</InputLabel>
                        <Select
                          onChange={(e) => setYear(e.target.value)}
                          labelId="year-select-label"
                          id="year-select"
                          label="Year"
                          value={year}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 150,
                              },
                            },
                          }}
                        >
                          {Array.from({ length: 12 }, (_, i) => 2024 + i).map(
                            (year) => (
                              <MenuItem key={year} value={year}>
                                {year}
                              </MenuItem>
                            )
                          )}
                        </Select>
                      </FormControl> */}
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          label="Year"
                          views={["year"]}
                          value={dayjs(`${year}`)}
                          onChange={(newValue) => {
                            if (newValue) {
                              setYear(newValue.year());
                            }
                          }} slotProps={{
                            textField: {
                              size: "small",
                              sx: { width: "100px", }
                            },
                          }}
                        />
                      </LocalizationProvider>

                    </div>
                    <h3>Total Sales Revenue Yearly</h3>
                    <LineChart
                      dataset={dataSet}
                      xAxis={[
                        {
                          dataKey: "x",
                          label: "Months (Amount Paid)",
                          valueFormatter: (value) => monthLabels[value],
                        },
                      ]}
                      yAxis={[
                        {
                          dataKey: "y",
                          ticks: ["payments"],
                          margin: { left: 50 },
                        },
                      ]}
                      series={[{ dataKey: "y", color: "#E37B00" }]}
                      height={300}
                      margin={{ left: 50, right: 30, top: 30, bottom: 65 }}
                      grid={{
                        vertical: { lineStyle: "dotted" },
                        horizontal: { lineStyle: "dotted" },
                      }}
                    />
                  </div>
                </CardContent>
              </Card>
            </div>
          </div> : null}

      </div>
    </div >
  );
};

export default AdminDashboard;
{/* <FormControl className="piechart-select">
                          <InputLabel id="demo-simple-select-label">
                            Select Type
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label="Category"
                            defaultValue="Category"
                          >
                            <MenuItem
                              defaultValue="Category"
                              value="Category"
                              onClick={() => setType("Category")}
                            >
                              Category
                            </MenuItem>
                            <MenuItem
                              value="SubCategory"
                              onClick={() => setType("SubCategory")}
                            >
                              SubCategory
                            </MenuItem>
                            <MenuItem
                              value="DesignType"
                              onClick={() => setType("DesignType")}
                            >
                              DesignType
                            </MenuItem>
                          </Select>
                        </FormControl> */}
{/* <FormControl sx={{ width: '200px' }}>
                        <InputLabel id="demo-simple-select-label">
                          Status Filters
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Status Filters"
                          defaultValue="SubOrder"
                          onChange={(e) => setOrderType(e.target.value)}
                        >
                          <MenuItem
                            defaultValue="SubOrder"
                            value="SubOrder"
                          >
                            SubOrders
                          </MenuItem>
                          <MenuItem
                          defaultValue="Order"
                            value="SubOrder"
                          >
                            Sub Orders
                          </MenuItem>
                          <MenuItem
                            value="Consultation"
                          >
                            Consultations
                          </MenuItem>
                        </Select>
                      </FormControl> */}
{/* <div className='dashboard-bargraph'>
          <Card>
            <CardContent>
              <div className="chart-container">
                <div className="bar-header">
                  <div>
                    <Typography variant="h2">Orders Status</Typography>
                    <Typography variant="h3">Here you can check the status of all the orders</Typography>
                  </div>
                  <FormControl className="piechart-select">
                    <InputLabel id="demo-simple-select-label">
                      Status Filters
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Status"
                      defaultValue="Order"
                    >
                      <MenuItem
                        defaultValue="Order"
                        value="Order"
                        onClick={() => setStatusType("Order")}
                      >
                        Orders
                      </MenuItem>
                      <MenuItem
                        value="SubOrder"
                        onClick={() => setStatusType("SubOrder")}
                      >
                        Sub Orders
                      </MenuItem>
                      <MenuItem
                        value="Consultation"
                        onClick={() => setStatusType("Consultation")}
                      >
                        Consultations
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <ReactApexChart
                  options={barChartOptions}
                  series={barChartSeries}
                  type="bar"
                  height={500}
                />
              </div>
            </CardContent>
          </Card>
        </div> */}

{/* <Card>
          <CardContent>
            <div className="yearly-revenue">
              <div>
                <Typography variant="h2">₹ 12,555</Typography>
                <Typography variant="h3">Total Sales Revenue Yearly</Typography>
              </div>
              <FormControl
                className="year-select"
                variant="outlined"
                sx={{ width: "100px", marginBottom: "2px" }}
              >
                <InputLabel id="year-select-label">Filters</InputLabel>
                <Select
                  labelId="year-select-label"
                  id="year-select"
                  label="Year"
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 150,
                      },
                    },
                  }}
                >
                  {Array.from({ length: 12 }, (_, i) => 2024 + i).map(
                    (year) => (
                      <MenuItem key={year} value={year}>
                        {year}
                      </MenuItem>
                    )
                  )}
                </Select>
              </FormControl>
            </div>
          </CardContent>
        </Card> */}